import { Component, OnInit, Input, ViewChild, Optional, Self, EventEmitter, Output } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import * as uuid from 'uuid';
import { SelectDropdownComponent } from './dropdown/dropdown.component';

@Component({
    selector: 'app-form-select',
    templateUrl: './select.component.html',
    styleUrls: ['./select.component.scss'],
})
export class SelectComponent implements OnInit, ControlValueAccessor {
    public onChange: (x?: any) => void;

    public onTouched: (x?: any) => void;

    public id: string;

    public _value: any = '';

    public _options: any[];

    @Input() required: boolean;

    @Input() invalid: boolean;

    @Input() disabled: boolean;

    @Input() placeholder = '';

    @Input() label: string;

    @Input() searchable = false;

    @Input() noFormControlBorder = false;

    @Input() displayMessages = true;

    @Output('change') changeOutput = new EventEmitter<any>();

    @ViewChild(SelectDropdownComponent)
    public dropdown: SelectDropdownComponent;

    public searchTerm = '';

    @Input()
    get options(): any[] {
        return this._options;
    }

    set options(data) {
        const mappedData = data?.map((item) => {
            if (item.hasOwnProperty('name')) {
                item.label = item.name;
                delete item.name;
            }
            return item;
        });
        this._options = mappedData;
    }

    get filteredOptions(): any[] {
        if (!this.searchTerm) {
            return this.options;
        }

        const search = this.searchTerm.toLowerCase();
        return this.options.filter((option) => option.label?.toLowerCase().includes(search));
    }

    constructor(@Self() @Optional() private ngControl: NgControl) {
        if (this.ngControl) {
            this.ngControl.valueAccessor = this;
        }
    }

    ngOnInit(): void {
        this.id = uuid.v4();
        if (this.value) {
            this.select(this.options?.find((i) => i.value === this.value));
        }
    }

    get value(): any {
        return this._value;
    }

    set value(v) {
        this._value = v;
        if (this.onChange) {
            this.changeOutput.emit(v);
            this.onChange(v);
            this.onTouched();
        }
    }

    change(v): void {
        this._value = v;
    }

    writeValue(value: any): void {
        this.value = value;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    registerOnChange(fn: any): void {
        // Store the provided function as an internal method.
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        // Store the provided function as an internal method.
        this.onTouched = fn;
    }

    select(value): void {
        this.writeValue(value);
        if (this.searchable && value) {
            this.searchTerm = value.label;
        }
        this.hideDropdown();
    }

    public onSearchChange(event: any): void {
        this.searchTerm = event.target.value;
        if (!this.dropdown.showing) {
            this.showDropdown();
        }
    }

    public toggleDropdown(): void {
        if (this.dropdown.showing) {
            this.hideDropdown();
        } else {
            this.showDropdown();
        }
    }

    public showDropdown(): void {
        this.dropdown.show();
    }

    public hideDropdown(): void {
        this.dropdown?.hide();
    }
}
